(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["divag-cart-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('divag-cart-extras')) {
    class DivagCartExtras extends HTMLElement {
      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onChange = event => {
          const card = event.target.closest('[data-product-id]');
          if (card) this.updateCard(card);
        };
        this.onCart = event => {
          this.dataset.total = event.detail.total_price;
          this.dataset.currency = event.detail.currency;
          if (event.detail.items) {
            const eligible = ['vertikal-pantalon-de-danse','vertikal-short','vertikal-t-shirt','le-sac-training','vertikal-t-shirt-edition-campus','vertikal-t-shirt-edition-tag','vertikal-t-shirt-edition-icy','vertikal-t-shirt-edition-blurry'];
            this.dataset.giftEligibleTotal = event.detail.items.reduce((total, item) => total + (eligible.includes(item.handle) ? item.original_line_price : 0), 0);
          }
          this.updateCards();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        document.addEventListener('divag:cart-updated', this.onCart);
        this.updateCards();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        document.removeEventListener('divag:cart-updated', this.onCart);
      }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        }).format(cents / 100);
      }
      updateCards() {
        this.querySelectorAll('[data-product-id]').forEach(card => this.updateCard(card));
      }
      updateCard(card) {
        const picker = card.querySelector('[data-extras-variant]');
        const selected = picker.tagName === 'SELECT' ? picker.selectedOptions[0] : picker;
        const price = Number(selected.dataset.price || card.dataset.minPrice);
        card.querySelector('[data-extras-price]').textContent = this.money(price);
        card.querySelector('[data-extras-add]').textContent = this.dataset.add;
        const threshold = Number(window.theme?.settings?.cart_free_shipping_threshold);
        const benefit = card.querySelector('[data-extras-benefit]');
        if (card.dataset.gift === 'true') {
          const qualifies = Number(this.dataset.giftEligibleTotal) >= 10000;
          benefit.hidden = false;
          benefit.textContent = qualifies
            ? (document.documentElement.lang === 'en' ? 'Free at checkout with this offer' : 'Offerte au panier avec cette offre')
            : (document.documentElement.lang === 'en' ? 'Free with EUR 100 of eligible products' : 'Offerte dès 100 € de produits éligibles');
          if (qualifies) {
            card.querySelector('[data-extras-price]').textContent = document.documentElement.lang === 'en' ? 'FREE' : 'OFFERTE';
            card.querySelector('[data-extras-add]').textContent = document.documentElement.lang === 'en' ? 'Add my cap' : 'Ajouter ma casquette';
          }
          return;
        }
        const remaining = threshold - Number(this.dataset.total);
        benefit.hidden = !(threshold > 0 && this.dataset.currency === 'EUR');
        benefit.dataset.qualifies = 'false';
        if (remaining <= 0) {
          benefit.textContent = this.dataset.ready;
        } else if (price >= remaining) {
          benefit.textContent = this.dataset.qualifies;
          benefit.dataset.qualifies = 'true';
        } else {
          benefit.textContent = this.dataset.remaining.replace('[amount]', this.money(remaining - price));
        }
      }
      async handleClick(event) {
        const button = event.target.closest('[data-extras-add]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        if (window.divagCartAdding) return;
        const card = button.closest('[data-product-id]');
        const picker = card.querySelector('[data-extras-variant]');
        if (!picker.value) {
          picker.reportValidity();
          picker.focus();
          return;
        }
        const selected = picker.tagName === 'SELECT' ? picker.selectedOptions[0] : picker;
        if (selected.disabled) return;
        const error = this.querySelector('.dv-extras__error');
        error.hidden = true;
        window.divagCartAdding = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        const drawer = document.querySelector('cart-drawer');
        const inDrawer = !!this.closest('cart-drawer');
        const main = document.querySelector('cart-items');
        const mainSection = main?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
        const sections = ['cart-drawer', 'cart-counter'];
        if (mainSection) sections.push(mainSection);
        let added = false;
        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: picker.value, quantity: 1 }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          added = true;
          const replacements = [];
          const targets = [
            ['cart-drawer', 'cart-drawer #CartDrawer-Body'],
            ['cart-counter', '#shopify-section-cart-counter'],
            ...(mainSection ? [[mainSection, 'cart-items']] : [])
          ];
          for (const [section, selector] of targets) {
            const target = document.querySelector(selector);
            if (!target) continue;
            const html = result.sections?.[section];
            const parsed = html && new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
            if (!parsed) throw new Error(this.dataset.error);
            replacements.push([target, parsed.innerHTML]);
          }
          replacements.forEach(([target, html]) => { target.innerHTML = html; });
          await updateFreeShipping();
          await updateCartCounters();
          const focusTarget = inDrawer ? drawer?.querySelector('[data-drawer-close]') : document.querySelector('cart-items [name="checkout"]');
          focusTarget?.focus({ preventScroll: true });
        } catch (failure) {
          if (added) {
            window.location.assign(window.routes.cart_url);
          } else {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
          }
        } finally {
          window.divagCartAdding = false;
          button.disabled = false;
          if (this.isConnected) this.updateCard(card);
        }
      }
    }
    customElements.define('divag-cart-extras', DivagCartExtras);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divag-hem-feature"] && !Shopify.designMode) return;
  try {
    (() => {
    const buildSlide = (feature, thumbnail) => {
      const slide = document.createElement('div');
      const media = document.createElement('div');
      const image = document.createElement('img');
      const slideId = `divag-hem-adaptable-${feature.dataset.sectionId}`;

      slide.className = 'swiper-slide divag-hem-gallery-slide';
      slide.dataset.mediaId = slideId;
      slide.dataset.mediaType = 'image';
      slide.dataset.divagHemSlide = '';

      media.className = thumbnail ? 'media media--thumb' : 'media';
      image.src = feature.dataset.imageUrl;
      image.alt = feature.dataset.imageAlt;
      image.loading = 'lazy';
      image.width = thumbnail ? 160 : 1122;
      image.height = thumbnail ? 200 : 1402;
      media.appendChild(image);

      if (!thumbnail) {
        const caption = document.createElement('span');
        const title = document.createElement('span');
        const rule = document.createElement('span');
        const subtitle = document.createElement('span');

        caption.className = 'divag-hem-gallery-slide__caption';
        title.className = 'divag-hem-gallery-slide__title';
        rule.className = 'divag-hem-gallery-slide__rule';
        subtitle.className = 'divag-hem-gallery-slide__subtitle';
        title.textContent = feature.dataset.galleryTitle;
        subtitle.textContent = feature.dataset.gallerySubtitle;
        caption.append(title, rule, subtitle);
        media.appendChild(caption);
      }

      slide.appendChild(media);
      return slide;
    };

    const addGallerySlide = (section, feature, selector, thumbnail) => {
      const slider = section.querySelector(selector);
      const wrapper = slider?.querySelector('.swiper-wrapper');
      if (!slider || !wrapper || wrapper.querySelector('[data-divag-hem-slide]')) return;

      const slide = buildSlide(feature, thumbnail);
      if (slider.swiper && typeof slider.swiper.appendSlide === 'function') {
        slider.swiper.appendSlide(slide);
        slider.swiper.update();
      } else {
        wrapper.appendChild(slide);
      }
    };

    const mountFeature = (feature) => {
      if (feature.dataset.divagHemMounted === 'true') return;

      const section = feature.closest('.shopify-section');
      const dialog = feature.querySelector('.divag-hem-dialog');
      const trigger = feature.querySelector('.divag-hem-feature__trigger');
      const close = feature.querySelector('.divag-hem-dialog__close');
      const dialogVideo = feature.querySelector('.divag-hem-dialog__video');
      if (!section || !dialog || !trigger || !close) return;

      const stopDialogVideo = () => {
        if (!dialogVideo) return;
        dialogVideo.pause();
        dialogVideo.currentTime = 0;
      };

      feature.dataset.divagHemMounted = 'true';
      trigger.addEventListener('click', () => {
        dialog.showModal();
        if (!dialogVideo) return;
        dialogVideo.currentTime = 0;
        dialogVideo.play().then(() => {
          if (!dialog.open) stopDialogVideo();
        }).catch(() => {});
      });
      close.addEventListener('click', () => {
        stopDialogVideo();
        dialog.close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          stopDialogVideo();
          dialog.close();
        }
      });
      dialog.addEventListener('cancel', stopDialogVideo);
      dialog.addEventListener('close', stopDialogVideo);

      if (feature.dataset.includeGallerySlide !== 'false') {
        addGallerySlide(section, feature, '.swiper--product-gallery', false);
        addGallerySlide(section, feature, '.swiper--product-thumbs', true);
      }
    };

    const mountAll = (scope = document) => {
      scope.querySelectorAll('[data-divag-hem-feature]').forEach(mountFeature);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divag-product-upsell"] && !Shopify.designMode) return;
  try {
    if (!window.divagProductUpsellReady) {
    window.divagProductUpsellReady = true;

    document.addEventListener('change', async (event) => {
      const checkbox = event.target.closest('[data-divag-upsell-checkbox]');
      if (!checkbox) return;

      const upsell = checkbox.closest('[data-divag-upsell]');
      const status = upsell.querySelector('[data-divag-upsell-status]');
      const isAdding = checkbox.checked;
      const lineKey = upsell.dataset.lineKey;

      if (!isAdding && !lineKey) return;

      checkbox.disabled = true;
      upsell.setAttribute('aria-busy', 'true');

      try {
        const request = isAdding
          ? {
              url: upsell.dataset.addUrl,
              body: {
                items: [
                  {
                    id: Number(checkbox.value),
                    quantity: 1,
                    properties: {
                      _divag_upsell_source: `${upsell.dataset.source}:${Date.now()}`,
                    },
                  },
                ],
              },
            }
          : {
              url: upsell.dataset.changeUrl,
              body: { id: lineKey, quantity: 0 },
            };

        const response = await fetch(request.url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request.body),
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Cart update failed');

        if (isAdding) {
          upsell.dataset.lineKey = result.items?.[0]?.key || result.key || '';
          status.textContent = upsell.dataset.addedMessage;
        } else {
          delete upsell.dataset.lineKey;
          status.textContent = upsell.dataset.removedMessage;
        }

        document.dispatchEvent(
          new CustomEvent('divag:cart-updated', {
            detail: { action: isAdding ? 'add' : 'remove' },
          }),
        );
      } catch (error) {
        checkbox.checked = !isAdding;
        status.textContent = upsell.dataset.errorMessage;
      } finally {
        checkbox.disabled = false;
        upsell.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
